import { useEffect, useState } from "react";
import { toast } from "react-toastify";
// import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import "./index.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import brands from "../../data/brands.json";

// const RECAPTCHA_SITE_KEY = process.env.REACT_APP_SITE_KEY;

function Form() {

  const technologies = brands;

  // const { executeRecaptcha } = useGoogleReCaptcha();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    neededService: "Select Options",
    budget: "Select Options",
    message: "",
  });

  const neededServicesF = [
    "Select Options",
    "Ecommerce Website",
    "ERP Solutions",
    "SEO",
    "PR Marketing",
    "Dynamic Website",
    "Mobile Application Developement",
    "Social Media Marketing",
    "Virtual Assistance",
    "Website Customization",
    "Shopify Website Developement",
    "Shopify App Developement",
    "Ecommerce Management",
    "Startup Consultation",
    "Magento 1 & 2 Plugin Developement",
    "Performance Marketing",
    "TikTok Marketing",
    "Wordpress Plugin Developement",
    "Surveillance & CCTV",
  ];

  const budgetF = [
    "Select Options",
    "$1000-$5000",
    "$5000-$10,000",
    "$10,000-$100,000",
    "$100,000-$500,000",
    "$500,000+",
  ];


  const domain = window.location.hostname; // This will be "mean3.com" or "mean3.ae"

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const isEmpty =
      !form.name.trim() ||
      !form.company.trim() ||
      !form.email.trim() ||
      !form.phone.trim() ||
      !form.message.trim() ||
      form.neededService === "Select Options" ||
      form.budget === "Select Options";

    if (isEmpty) {
      toast.error("Please fill all the fields.");
      setLoading(false);
      return;
    }

    // if (!executeRecaptcha) {
    //   console.log(executeRecaptcha)
    //   toast.error("Recaptcha not ready.");
    //   setLoading(false);
    //   return;
    // }

    // const token = await executeRecaptcha("formSubmit");
    const jsonData = {
      name: form.name,
      company: form.company,
      email: form.email,
      phone: form.phone,
      neededService: form.neededService,
      budget: form.budget,
      message: form.message,
      sourceDomain: domain, // ✅ This will tell backend which domain submitted the form
      // token: token,
    };
    // const formData = new FormData();
    // formData.append("Name", form.name);
    // formData.append("Company", form.company);
    // formData.append("Email", form.email);
    // formData.append("Phone", form.phone);
    // formData.append("Needed Service", form.neededService);
    // formData.append("Budget", form.budget);
    // formData.append("Message", form.message);
    // formData.append("_template", "table");
    // formData.append("_captcha", "false");
    // formData.append("g-recaptcha-response", token);

    //     for (let pair of formData.entries()) {
    //   console.log(pair[0]+ ', ' + pair[1]);
    // }

    try {
      const response = await fetch(
        `https://mean3.ae/Email/sendEmailContactMean3.php`,
        {
          method: "POST",
          // body: formData,
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(jsonData),
        }
      );
      // console.log(response.body,"res");
      const res = response.json();
      console.log(res);

      if (response.ok) {
        toast.success("Form submitted successfully!");

        // if (onSubmit) onSubmit();

        setForm({
          name: "",
          company: "",
          email: "",
          phone: "",
          neededService: "Select Options",
          budget: "Select Options",
          message: "",
        });
      } else {
        toast.error("Failed to submit form.");
      }

    } catch (error) {
      toast.error("Something went wrong.");
    }

    setLoading(false);
  };

  const settings = {
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 12,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 12 } },
      { breakpoint: 850, settings: { slidesToShow: 5 } },
    ],
  };

  return (
    <div className="w-full bg-[#f8f9fb] py-14 px-2 font-inter font-[400]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 px-4 sm:px-6 lg:px-8 py-10 rounded-lg shadow-sm align-items-center">

        {/* LEFT: Success Info */}
        <div className="text-left mt-5 w-full">
          {/* Mobile: one-line heading */}
          <h2 className="block sm:hidden text-[28px] text-[#0b1534] mb-10 leading-snug whitespace-nowrap">
            Start your success story
          </h2>

          {/* Tablet/Desktop: broken into two lines */}
          <h2 className="hidden sm:block text-[36px] lg:text-[40px] text-[#0b1534] mb-10 xl:leading-[48px]">
            Start your success <br /> story
          </h2>

          {/* Steps */}
          {[1, 2, 3].map((step, index) => {
            const stepContent = [
              {
                title: 'We get to know your business needs',
                desc: 'Together, we’ll dive into your goals, challenges, and opportunities to craft a clear digital vision tailored to your needs.',
              },
              {
                title: 'Initial strategic expertise',
                desc: 'We’ll share our holistic expertise with you for free to ensure you make informed next steps.',
              },
              {
                title: 'Free proposal design',
                desc: 'To kick off our cooperation in design, we offer a free proposal design that serves as a starting point for the creative project.',
              },
            ];
            return (
              <div key={step} className="flex items-start gap-4 mb-12 sm:mb-10 -mt-3 ">
                <div className="min-w-[32px] h-8 bg-red-600 text-white text-sm font-bold rounded-full flex items-center justify-center">
                  {step}
                </div>

                <div>
                  <h4 className="text-[16px] md:text-[18px] text-[#0b1534] mb-1 xl:leading-[32px]">{stepContent[index].title}</h4>
                  <p className="!text-[14px] md:!text-base text-[#60697b] xl:leading-[24px]">{stepContent[index].desc}</p>
                </div>
              </div>
            );
          })}

          {/* Logos */}
          <div className="sm:pt-14 pb-6 sm:pb-8">
            <div className="max-w-7xl mx-auto">
              <h3 className="text-[#0b1534] text-[16px] sm:text-lg mb-1">
                Trusted by leading brands
              </h3>

              <div className="overflow-hidden relative">
                {/* Left shadow */}
                <div className="absolute left-0 top-0 h-full w-20 z-10 bg-gradient-to-r from-[#f8f9fb] to-transparent pointer-events-none"></div>

                {/* Right shadow */}
                <div className="absolute right-0 top-0 h-full w-20 z-10 bg-gradient-to-l from-[#f8f9fb] to-transparent pointer-events-none"></div>

                {/* Marquee logos */}
                <div className="flex animate-marquee whitespace-nowrap w-max">
                  {technologies.concat(technologies).map((tech, index) => (
                    <a
                      href={tech.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={index}
                      className="flex items-center justify-center mx-1 bg-white p-3 rounded-md shadow-md min-w-[120px] transition hover:scale-105"
                    >
                      <img src={tech.icon} alt={tech.name} className="h-8 object-contain" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* RIGHT: Form */}

        <div className="bg-[#f8f9fb] px-4 sm:px-6 md:px-10 py-14 shadow-md w-full lg:mt-[-30px]">
          <p className="text-[#0b1534] mb-6 !text-[24px] xl:leading-[32px] max-[639px]:!text-[20px] max-[639px]:leading-[28px] ml-2">
            <span className="text-red-600">It doesn't cost anything</span> – schedule a call to explore how we can help your business grow
          </p>

          <form onSubmit={handleSubmit} method="Post" className="flex flex-wrap w-full -mx-[7.5px] ml-0">
            <InputField label="Name" value={form.name} onChange={(val) => setForm({ ...form, name: val })} name="name" />
            <InputField label="Phone Number" value={form.phone} onChange={(val) => setForm({ ...form, phone: val })} name="phone" />
            <InputField label="E-Mail Address" value={form.email} onChange={(val) => setForm({ ...form, email: val })} name="email" type="email" />
            <InputField label="Company Website" value={form.company} onChange={(val) => setForm({ ...form, company: val })} name="company" />
            <SelectField label="Needed Service" value={form.neededService} onChange={(val) => setForm({ ...form, neededService: val })} name="neededService" options={neededServicesF} />
            <SelectField label="Budget" value={form.budget} onChange={(val) => setForm({ ...form, budget: val })} name="budget" options={budgetF} />

            <div className="w-full px-[7.5px] mb-5">
              <label htmlFor="message" className="block text-xs font-medium text-gray-600 mb-1 uppercase">
                How can we help? <span className="text-red-500">*</span>
              </label>
              <textarea
                name="message"
                id="message"
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                rows={5}
                required
                className="block w-full border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white resize-none"
              />
            </div>

            <div className="w-full px-[7.5px] mt-8">
              <button
                name="button"
                type="submit"
                disabled={loading}
                className="bg-red-600 text-white py-3 sm:py-4 px-7 rounded-full font-medium transition hover:bg-red-700 text-[16px] sm:text-[18px] 
  w-full max-w-[300px] block mx-auto sm:mx-0 sm:w-auto text-center"
              >
                {loading ? "Sending..." : "Send message"}
              </button>

            </div>
          </form>
        </div>
      </div>
    </div >
  );
}

// ------------------------
// Input Field Component
// ------------------------
const InputField = ({ label, value, onChange, name, type = "text" }) => (
  <div className="w-full md:w-1/2 px-[7.5px] mb-5">
    <label
      htmlFor={name}
      className="block text-sm font-normal text-gray-500 mb-1"
    >
      {label} <span className="text-red-500">*</span>
    </label>
    <input
      name={name}
      id={name}
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full border border-gray-300 rounded-md px-4 py-4 text-[15px] text-gray-700 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
      required
    />
  </div>
);

// ------------------------
// Select Field Component
// ------------------------
const SelectField = ({ label, value, onChange, name, options }) => (
  <div className="w-full md:w-1/2 px-[7.5px] mb-4 relative">
    <label
      htmlFor={name}
      className="block text-xs font-medium text-gray-600 mb-1 uppercase"
    >
      {label} <span className="text-red-500">*</span>
    </label>
    <select
      name={name}
      id={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required
      className="block w-full border border-[#d9d9d9] rounded-md px-3 py-4 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-red-400 bg-white appearance-none"
    >
      {options.map((item) => {
        const val = item.toLowerCase().replaceAll(" ", "-");
        return (
          <option key={val} value={item}>
            {item}
          </option>
        );
      })}
    </select>
    {/* Dropdown icon */}
    <svg
      className="absolute top-[36px] right-4 w-4 h-4 text-gray-500 pointer-events-none"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.586l3.71-4.356a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
        clipRule="evenodd"
      />
    </svg>
  </div>
);

export default Form;
